import { render, staticRenderFns } from "./PracticeTestRecords.vue?vue&type=template&id=1e534a14&scoped=true"
import script from "./PracticeTestRecords.vue?vue&type=script&lang=js"
export * from "./PracticeTestRecords.vue?vue&type=script&lang=js"
import style0 from "./PracticeTestRecords.vue?vue&type=style&index=0&id=1e534a14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e534a14",
  null
  
)

export default component.exports